import { WorkpackService } from 'client/services';

const loader = async ({ request }) => {
    const url = new URL(request.url);
    const workpackRequests = await WorkpackService.getWorkpackRequests(url?.searchParams);

    return { workpackRequests };
};

export default loader;
